/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2020/3/24
 */
import React from 'react'
import {ApplyPluginsType} from 'umi'
import {renderRoutes} from '/builds/oem/oem-fe-work-manager/node_modules/@umijs/renderer-react/dist/index.js';
import {matchRoutes} from '/builds/oem/oem-fe-work-manager/node_modules/react-router-config/index.js'
import { routerRedux } from 'dva'

const Router = routerRedux.ConnectedRouter

function RouterComponent(props) {
    const {history, ...renderRoutesProps} = props

    React.useEffect(() => {
        if (window.g_initialProps) {
          window.g_initialProps = null;
        }
        function routeChangeHandler(location, action) {
            const matchedRoutes = matchRoutes(props.routes, location.pathname)

            props.plugin.applyPlugins({
                key: 'onRouteChange',
                type: ApplyPluginsType.event,
                args: {
                    routes: props.routes,
                    matchedRoutes,
                    location,
                    action,
                },
            })
        }

        routeChangeHandler(history.location, 'POP')
        return history.listen(routeChangeHandler)
    }, [history])

    return <Router history={history}>{renderRoutes(renderRoutesProps)}</Router>
}

export function rootContainer(container, {history, routes, plugin}) {
    return (
        <RouterComponent
            history={history}
            routes={routes}
            plugin={plugin}
        />
    )
}
